<div id="onboarding-profile-page">

  <app-onboarding-stepper [currentStep]="1"></app-onboarding-stepper>
  <app-onboarding-header
    title="Étape 1 : Informations générales"
    content="Ces données seront visibles uniquement par les membres du communauté.">
  </app-onboarding-header>

  <div class="container-profile-picture">
    <div class="profile-title">Photo de profil</div>
    <div class="profile-description">Non obligatoire mais beaucoup plus convivial! 😉
    </div>
    <div (click)='inputFile.click()' *ngIf="!selectedFile && !communityId" class="container-upload-input">
      <img ngSrc="assets/images/icons/grey/plus.svg" alt="Icon plus" height="48" width="48">
    </div>
    <div *ngIf="selectedFile || communityId" class="container-picture-preview">
      <div class="preview-img">
        <img [src]="imagePreview" alt="profile picture preview"/>
      </div>
      <div class="container-preview-actions">
        <button mat-flat-button (click)="inputFile.click()"
                class="size-xs"
                color="accent"
                type="button">
          Changer de photo
        </button>
        <button mat-stroked-button (click)="onRemove()" *ngIf="selectedFile"
                class="size-xs base"
                type="button">
          <div class="icon">
            <img ngSrc="assets/images/icons/trash.svg" alt="Icon trash" width="20" height="20"> Supprimer
          </div>
        </button>
      </div>
    </div>
    <input #inputFile type='file' (change)='onFileSelected($event)' class='hidden' accept="image/png, image/jpeg">
  </div>

  <form *ngIf="profileForm" [formGroup]="profileForm" (submit)="createProfile()">
    <div class="container-input-inline">
      <mat-form-field>
        <mat-label>Prénom</mat-label>
        <input matInput placeholder="Saisissez un prénom" type="text" formControlName="firstName" required>
        <mat-error *ngIf="profileForm.controls['firstName'].hasError('required')">Veuillez saisir un prénom valide.
        </mat-error>
      </mat-form-field>
      <mat-form-field>
        <mat-label>Nom</mat-label>
        <input matInput type="text" placeholder="Saisissez un nom" formControlName="lastName" required>
        <mat-error *ngIf="profileForm.controls['lastName'].hasError('required')">Veuillez saisir un nom valide.
        </mat-error>
      </mat-form-field>
    </div>
    <div class="container-input-inline">
      <mat-form-field>
        <mat-label>Surnom</mat-label>
        <input matInput type="text" placeholder="Saisissez un surnom" formControlName="nickName">
      </mat-form-field>
<!--      <mat-form-field-->
<!--        matTooltip="Chez CoucouVisio, nous utilisons la date de naissance pour envoyer une carte d'anniversaire personnalisée à votre proche le jour de son anniversaire.">-->
<!--        <mat-label>Date de naissance</mat-label>-->
<!--        <input matInput type="date" formControlName="birthDate">-->
<!--      </mat-form-field>-->
    </div>
    <mat-form-field>
      <mat-label>Numéro de téléphone du proche</mat-label>
      <input matInput placeholder="Saisissez un numéro de téléphone" type="text" formControlName="phone" required>
      <mat-error *ngIf="profileForm.controls['phone'].hasError('required')">Veuillez saisir un numéro de téléphone
        valide.
      </mat-error>
      <mat-error *ngIf="profileForm.controls['phone'].hasError('pattern')">Le format du numéro n'est pas bon. (ex:
        06xxxxxx21)
      </mat-error>
    </mat-form-field>

    <div>
      <div class="admin-account-title">Compte du responsable de la communauté</div>
      <div class="container-input-inline">
        <mat-form-field>
          <mat-label>Prénom</mat-label>
          <input matInput placeholder="Saisissez un prénom" type="text" formControlName="creatorFirstName" required>
          <mat-error *ngIf="profileForm.controls['creatorFirstName'].hasError('required')">Veuillez saisir un prénom valide.
          </mat-error>
        </mat-form-field>
        <mat-form-field>
          <mat-label>Nom</mat-label>
          <input matInput type="text" placeholder="Saisissez un nom" formControlName="creatorLastName" required>
          <mat-error *ngIf="profileForm.controls['creatorLastName'].hasError('required')">Veuillez saisir un nom valide.
          </mat-error>
        </mat-form-field>
      </div>
      <mat-form-field>
        <mat-label>Email</mat-label>
        <input matInput placeholder="Email" type="email" formControlName="creatorEmail" required>
        <mat-error *ngIf="profileForm.controls['creatorEmail'].hasError('pattern')">Veuillez saisir un email valide (ex:
          exemple@gmail.com).
        </mat-error>
        <mat-error *ngIf="profileForm.controls['creatorEmail'].hasError('required')">Ce champ est obligatoire.</mat-error>
      </mat-form-field>
      <mat-form-field>
        <mat-label>Lien de parenté avec le proche</mat-label>
        <mat-select formControlName="relationship">
          <mat-option *ngFor="let relationship of getRelationshipValues()" [value]="relationship.value">
            {{ relationship.content }}
          </mat-option>
        </mat-select>
        <mat-error *ngIf="profileForm.controls['relationship'].hasError('required')">Veuillez sélectionner un lien de
          parenté.
        </mat-error>
      </mat-form-field>
    </div>

    <div class="container-actions">
      <div></div>
      <button mat-flat-button
              color="accent"
              type="submit"
              [disabled]="!profileForm.valid">
        <div class="icon">
          Suivant <img ngSrc="assets/images/icons/white/arrow-right.svg" alt="Icon arrow right" width="24" height="24">
        </div>
      </button>
    </div>
  </form>

</div>
